module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('article', {
    staticClass: "title is-parent box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("App Builds")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7113531e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Apps/app-builds.vue
// module id = 634
// module chunks = 30